import { toast, Bounce } from 'react-toastify';
import { getUserFacingError } from './userMessages';

const DEFAULT_TOAST_OPTIONS = Object.freeze({
  position: 'bottom-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'colored',
  transition: Bounce,
});

/**
 * Show a consistent, user-safe error toast.
 * Returns the resolved user-facing error object (useful for inline banners).
 *
 * @param {unknown} err
 * @param {object} [opts]
 * @param {string} [opts.operation]
 * @param {boolean} [opts.showToast]
 * @param {string} [opts.toastId]
 */
export function notifyError(err, opts = {}) {
  const info = getUserFacingError(err, opts.operation);

  if (opts.showToast !== false) {
    toast.error(info.message, {
      ...DEFAULT_TOAST_OPTIONS,
      toastId: opts.toastId || `${info.operation || 'unknown'}:${info.kind}:${info.status || 'na'}`,
    });
  }

  return info;
}

